import jsonBeautify from 'json-beautify'

const prettifyJsonString = (string) => {
  if (!string) return ''

  // 先嘗試把整段字串當作合法 JSON 來處理
  try {
    const obj = JSON.parse(string)

    const parseNestedJsonString = (value) => {
      if (typeof value !== 'string') return value
      const trimmed = value.trim()

      // 像 "{\"...\"}" 或 "[\"...\"]" 這種包在字串裡的 JSON
      if (
        (trimmed.startsWith('{') && trimmed.endsWith('}'))
        || (trimmed.startsWith('[') && trimmed.endsWith(']'))
      ) {
        try {
          return JSON.parse(trimmed)
        } catch (e) {
          return value
        }
      }

      return value
    }

    // 常見會塞 JSON 字串的欄位
    const nestedKeys = [
      'message',
      'settleInfo',
      'betInfo',
      'betGameModes',
      'betLimit',
      'svcasinoBetLimitId',
    ]

    nestedKeys.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj[key] = parseNestedJsonString(obj[key])
      }
    })

    let str = jsonBeautify(obj, null, 2, 1)

    // 類似原本邏輯，把特定欄位再轉回字串顯示
    str = str.replace(
      /("(?:message|betLimit|svcasinoBetLimitId)": ?){([\d\D\s]*)}(\n})/g,
      '$1"{$2}"$3',
    ) // greedy
    str = str.replace(
      /"settleInfo": ?{([\d\D\s]*?)}(?!,)/g,
      '"settleInfo": "{$1}"',
    )
    str = str.replace(
      /"betInfo": ?\[(\s*){([\d\D\s]*?)}(\s*)]/g,
      '"betInfo": [$1"{$2}"$3]',
    )
    str = str.replace(
      /"betGameModes": ?\[(\s*)([\d\D\s]*?)\](?!,)/g,
      '"betGameModes": "[$1$2]"',
    )

    return str
  } catch (e) {
    // 如果不是標準 JSON，就退回舊的處理流程
  }

  let str = string.replaceAll('\\', '')

  // Remove the double quotes to make the fields below be object or array
  str = str.replace(
    /("(?:message|betLimit|svcasinoBetLimitId)": ?)"{(.*?)}"/g,
    '$1{$2}',
  ) // key == message || betLimit || svcasinoBetLimitId 的 "{}"
  str = str.replace(
    /("(?!message)\w+": ?)(.?)"{(.*?)}"(.?)/g,
    '$1$2{$3}$4',
  ) // key != message 的 "{}"
  str = str.replace(
    /("(?!message)\w+": ?)(.?)"\[(.*?)\]"(.?)/g,
    '$1$2[$3]$4',
  ) // key != message 的 "[]"

  try {
    str = JSON.parse(str)
    str = jsonBeautify(str, null, 2, 1)
  } catch (error) {
    console.log('parsed failed string', string)
    console.log('parsed failed str', str)
    console.error(error)
  }

  // Add the double quotes back to make the fields below be string
  // - message "{}"
  // - settleInfo "{}" (LUCKYPOKER, PTLIVE)
  // - betInfo ["{}"] (LUCKYPOKER, PTLIVE)
  // - betGameModes "[]" (VIACASINO)
  str = str.replace(
    /("(?:message|betLimit|svcasinoBetLimitId)": ?){([\d\D\s]*)}(\n})/g,
    '$1"{$2}"$3',
  ) // greedy
  str = str.replace(
    /"settleInfo": ?{([\d\D\s]*?)}(?!,)/g,
    '"settleInfo": "{$1}"',
  )
  str = str.replace(
    /"betInfo": ?\[(\s*){([\d\D\s]*?)}(\s*)]/g,
    '"betInfo": [$1"{$2}"$3]',
  )
  str = str.replace(
    /"betGameModes": ?\[(\s*)([\d\D\s]*?)\](?!,)/g,
    '"betGameModes": "[$1$2]"',
  )

  return str
}

export default prettifyJsonString
